import { Routes, Route, useParams, useLocation } from "react-router-dom";
import ProfileHeader from "./DetailsComponents/ProfileHeader";
import ViewProfile from "./DetailsComponents/ViewProfile";
import ProfileOverview from "./DetailsComponents/ProfileOverview";
import CareerSupport from "./DetailsComponents/CareerSupport";
import PostAndNetworksDetails from "./DetailsComponents/PostAndNetworksDetails";
import AttendedEvents from "./DetailsComponents/AttendedEvents";
import SubmittedAbstracts from './DetailsComponents/SubmittedAbstracts'

const UserProfileDetails = () => {
  const { '*': subPath } = useParams();
  const location = useLocation();

  const titleMap = {
    "view-profile": "Profile Details",
    "career-support": "Applied Job",
    "post-networks": "Post & Networks Details",
    "attended-events": "Attended Events",
    "submitted-abstracts" : "Submitted Abstracts"
  };

  const getPageTitle = () => {
    const found = Object.entries(titleMap).find(([key]) =>
      location.pathname.includes(key)
    );
    return found ? found[1] : "Profile Details";
  };


 
  return (
    <div>
      <ProfileHeader title={getPageTitle()} />
      <Routes>
        <Route index element={<ProfileOverview />} />
        <Route path="view-profile" element={<ViewProfile />} />
        <Route path="career-support" element={<CareerSupport />} />
        <Route path="post-networks" element={<PostAndNetworksDetails />} />
        <Route path="attended-events" element={<AttendedEvents />} />
        <Route path="submitted-abstracts/:eventId" element={<SubmittedAbstracts />} />
      </Routes>
    </div>
  );
};

export default UserProfileDetails;


